export const extractUrls = (inputText: string) => {
  // Regular expression to match URLs that end with a space or the end of the string
  const urlRegex =
    /\b(?:https?:\/\/|www\.)[^\s)]+(?=\s|$)|\b[a-z0-9.-]+\.[a-z]{2,}(?=\s|$)|\[(.*?)\]\((https?:\/\/[^\s)]+|www\.[^\s)]+)(?:\s+"[^"]*")?\)/gi;
  const matches = [...inputText.matchAll(urlRegex)];

  // Extract URLs from both direct matches and Markdown-style links with optional titles
  const extractedUrls = matches.map(
    (match) => match[2] ?? match[0] // `match[2]` for Markdown links, `match[0]` for direct links
  );

  return extractedUrls;
};
